module.exports = __webpack_public_path__ + "static/media/1.8cd325c5.jpg";